var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 369,
    height: 215,
    viewBox: "0 0 369 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(-781 -1587.719)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 369,
    height: 215,
    rx: 6,
    transform: "translate(781 1587.719)",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M-2161,1821.142s107.331-79.921,108.407-79.3,74.046,50.349,74.046,50.349,104.556-73.5,105.205-73.647,81.234,78.379,81.234,78.379V1856.9H-2161Z",
    transform: "translate(2942 -54.178)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(814 1607.719)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    transform: "translate(781 1587.719)",
    fill: "none",
    stroke: "#009ee2",
    strokeWidth: 1,
    strokeDasharray: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 215,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 368,
    height: 214,
    rx: 5.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.1905d095f0c50c14ba799fc77af64b95.svg";
export { ForwardRef as ReactComponent };